import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import TableCasino from '../../../../../@casino/ui/table';
import Title from '../../../../../@casino/ui/title';
import {useRouter} from '../../../../../@casino/useRouter';
import { setGetDailyView } from '../../store/thunk/setGetDailyView';
import {getDate} from '../../../../../@casino/lib/getDate';
import { setGetLogin } from '../../store/thunk/setGetLogin';

const columns = [
    { id: 'id', label: 'ID'},
    { id: 'data', label: 'Дата'},
    { id: 'login', label: 'Логин'},
    { id: 'event', label: 'Событие'},
    { id: 'summ', label: 'Сумма'},
];

const DailyView = () => {
    const dispatch = useDispatch();
    const router = useRouter();
    const {id} = router.match.params;

    React.useEffect(() => {
        dispatch(setGetLogin({
            id
        }));
        dispatch(setGetDailyView({
            id,
            page: 1,
            rowsPerPage: 10,
        }))
    }, [id]); 

    const history = useSelector(state => state.daily.view);
    const login = useSelector(state => state.daily.login);
  
    const getRows = (value) => {
        return value.map((item) => {
            return {
                id: item.id,
                data: getDate(item.event_date),
                login: item.login,
                event: item.tag === 'replenishment' ? 'Пополнение' : 'Вывод',
                summ: new Intl.NumberFormat('ru-RU').format(item.summ) + '₽',
               
            }
        })
    } 
    
    const rows = getRows(history.result);

    return (
        <div style={{padding: 20, paddingTop: 0}}>
            <Title label={`Подробнее о ${login}`}/>

            <div style={{
                padding: 20, 
                background: '#1b2039', 
                borderRadius: 8, 
                marginBottom: 12,
            }}>
                <span style={{textTransform: 'uppercase', color: '#ffffff', fontWeight: 700, padding: '0 20px', cursor: 'pointer', userSelect: 'none', paddingBottom: 10, borderBottom: '2px solid #FF005C'}}>Все</span>
                <span style={{textTransform: 'uppercase', color: '#b0b0b0', fontWeight: 700, padding: '0 20px', cursor: 'pointer', userSelect: 'none'}}>Основные</span>
                <span style={{textTransform: 'uppercase', color: '#b0b0b0', fontWeight: 700, padding: '0 20px', cursor: 'pointer', userSelect: 'none'}}>Воздух</span>
                
            </div>

            <div style={{
                padding: 20, 
                background: '#1b2039', 
                borderRadius: 8, 
                marginBottom: 12,
            }}>
            
                <TableCasino
                    columns={columns}
                    rows={rows}
                    pagination
                    //todo all page
                    allPage={history.allPage}
                    perPage={10}

                    changePage={(v) => dispatch(setGetDailyView({
                        page: +v.page+1,
                        rowsPerPage: v.rowsPerPage,
                        id
                    }))}
                    changeRowsPerPage={(v) => dispatch(setGetDailyView({
                        page: +v.page + 1,
                        rowsPerPage: v.rowsPerPage,
                        id
                    }))}
                /> 
            </div>
        </div>
    )
}

export default DailyView;